import Vue from "vue";
import "vuetify/dist/vuetify.min.css";
import "vuetify/src/styles/main.sass";
import "vuetify/src/styles/styles.sass";
import Vuetify from "vuetify";
import de from "vuetify/es5/locale/de";
Vue.use(Vuetify);

export default new Vuetify({
  theme: {
    dark: false,
    options: {
      customProperties: true
    },
    themes: {
      light: {
        primary: "#7D9B38", //green
        secondary: "#546825", //darkgreen
        accent: "#f06914", //orange
        error: "#FF5252",
        info: "#2E3440", //grey
        success: "#4CAF50",
        warning: "#FFC107"
      }
    }
  },
  lang: {
    locales: { de },
    current: "de"
  }
});
